import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormError from '@enquiryForm/components/FormError';
function TextareaInput(props) {
    const { inputAttrs, labelAttrs } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control } = useFormContext();
    const { field: { onChange, value }, fieldState: { invalid, isTouched, error }, } = useController({ name, control });
    const className = clsx('form__control', forwardedInputClasses, { invalid: invalid && isTouched });
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx("textarea", { ...inputAttrs, onChange: onChange, value: value, className: className }), error && (_jsx(FormError, { children: error.message }))] }));
}
export default TextareaInput;
